// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaTiktok_root__32dES"};